import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function Popup({
  title,
  openPopup,
  setOpenPopup,
  setEdit,
  handleClose,
  children,
}) {
  return (
    <>
      <Dialog open={openPopup} onClose={handleClose}>
        <DialogTitle style={{ paddingBottom: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h5"
              style={{
                paddingTop: "2vw",
                textAlign: "center",
                color: "var(--white)",
                width: "90%",
                fontWeight: 600,
              }}
            >
              {title}
            </Typography>
            <IconButton
              edge="end"
              onClick={() => {
                if (setEdit) {
                  setEdit(false);
                }
                setOpenPopup(false);
              }}
              style={{
                marginRight: "1vw",
                marginTop: "2vw",
                borderRadius: "0.3vw",
                color: "var(--white)",
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{ width: "550px" }}>{children}</DialogContent>
      </Dialog>
    </>
  );
}

export default Popup;
